import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { StandardIntercomSearchTerm } from "app/standard-intercom-search-term";
import { RolesPageComponent } from "./roles-page.component";

const RolesPageTitle = "Roles";

export const rolesPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-roles-page", RolesPageComponent)
    .atOrganisationUrl("/architecture/roles")
    .verifyingFeatures(FeatureName.ArchitectureRoles)
    .withTitle(RolesPageTitle)
    .reloadOnSearch(false)
    .withHelp(StandardIntercomSearchTerm.ManageRoles)
    .build();
